export const Icon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="136" height="139" viewBox="0 0 136 139" fill="none">
            <path
                d="M2.71191 117.8L5.06647 44.7493C5.14688 42.2543 7.46775 40.4417 9.90787 40.9681L87.3992 57.6844C89.2409 58.0817 90.5557 59.7104 90.5557 61.5945V77.9759C90.5557 79.5827 89.5943 81.0335 88.1146 81.6596L2.71191 117.8Z"
                fill="url(#paint0_linear_19155_7107)"
                stroke="#BED0E5"
            />
            <path
                d="M98.9161 69.8163C92.7322 56.2123 77.5196 42.6449 68.8914 36.225C67.9595 35.5316 67.7775 34.1978 68.5137 33.2994L94.1923 1.95821C94.6733 1.37114 95.4434 1.10287 96.1354 1.41465C101.059 3.63335 112.451 13.0361 117.952 17.8386C132.222 32.5653 126.562 45.8554 121.948 50.6597L102.36 70.5034C101.322 71.5546 99.5274 71.161 98.9161 69.8163Z"
                fill="url(#paint1_linear_19155_7107)"
                stroke="#BED0E5"
            />
            <path
                d="M80.8496 32.9642L96.9747 13.1289M85.9868 37.1025L102.112 17.2672M90.1251 41.5263L106.25 21.6909M94.8342 46.2354L110.959 26.4"
                stroke="#BED0E5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M117.52 40.2421C122.452 42.5501 125.45 46.8085 120.236 52.3709C132.441 42.702 127.369 22.3893 114.525 14.9848C124.8 26.6863 120.637 38.171 117.52 40.2421Z"
                fill="url(#paint2_linear_19155_7107)"
                stroke="#BED0E5"
                stroke-miterlimit="16"
                stroke-linejoin="round"
            />
            <path
                d="M11.0726 56.0866L22.5666 69.5659C24.2541 71.5449 26.6463 72.7886 29.2355 73.0332L74.4195 77.3005C75.573 77.4094 76.5701 76.5021 76.5701 75.3434C76.5701 75.1671 76.5484 74.998 76.5007 74.8282C74.6166 68.1255 68.8104 52.7784 60.0169 42.9702C51.1124 33.0383 40.4194 36.2633 36.1859 39.1173L11.6082 53.049C10.5152 53.6686 10.2574 55.1306 11.0726 56.0866Z"
                fill="url(#paint3_linear_19155_7107)"
                stroke="#BED0E5"
            />
            <path
                d="M44.6049 46.3764C44.4907 40.4401 38.8017 39.194 36.1855 39.0989C52.2848 29.8098 63.2035 44.997 67.1515 53.0834C57.3337 42.4664 48.0297 44.1884 44.6049 46.3764Z"
                fill="url(#paint4_linear_19155_7107)"
                stroke="#BED0E5"
                stroke-miterlimit="16"
                stroke-linejoin="round"
            />
            <path
                d="M30.142 56.6942L3.02804 115.483C1.95624 117.807 3.31222 120.526 5.81333 121.068L83.4348 137.886C85.262 138.282 87.1197 137.359 87.9084 135.664L110.304 87.532C111.377 85.2253 110.053 82.5158 107.573 81.9461L72.6001 73.9118C71.1019 73.5676 69.9334 72.3953 69.5943 70.8959L68.0041 63.8655C67.659 62.34 66.4565 61.1556 64.9259 60.8336L34.5975 54.4551C32.7719 54.0711 30.9233 55.0001 30.142 56.6942Z"
                fill="url(#paint5_linear_19155_7107)"
                stroke="#BED0E5"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_19155_7107"
                    x1="20.8153"
                    y1="38.5417"
                    x2="46.6338"
                    y2="117.8"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.197745" stop-color="#F0F5FF" />
                    <stop offset="0.681183" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_19155_7107"
                    x1="97.098"
                    y1="1"
                    x2="64.9051"
                    y2="65.1704"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.269582" stop-color="#F0F5FF" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_19155_7107"
                    x1="116.416"
                    y1="40.7237"
                    x2="128.202"
                    y2="40.2872"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#BED0E5" />
                    <stop offset="1" stop-color="#B1C6DE" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_19155_7107"
                    x1="43.0355"
                    y1="36.2461"
                    x2="42.6421"
                    y2="93.108"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.225023" stop-color="#F0F5FF" />
                    <stop offset="1" stop-color="white" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_19155_7107"
                    x1="51.6685"
                    y1="36.7483"
                    x2="45.6972"
                    y2="47.7076"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#B1C6DE" />
                    <stop offset="1" stop-color="#BED0E5" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_19155_7107"
                    x1="73.6359"
                    y1="68.6631"
                    x2="56.6639"
                    y2="138.563"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.458215" stop-color="#F0F5FF" />
                    <stop offset="0.885335" stop-color="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};
